import * as Yup from "yup";

export const peopleSchemaProduct = Yup.object().shape({
  cpf_cnpj: Yup.string().required("Por favor, insira um cnpj."),
  company_name: Yup.string().required("Por favor, insira um nome."),
});
